import { ICardCompanyTabPrimary } from './types'
import { getInputButton } from '@primitive/getInputButton'
import { getCompanyAddressSuggestions } from '@api/companies/api'
import { ListenerAddressInput as AddressInput } from '../listenerAddressInput'

import { Flex, ToolTip, Textarea, Input, Divider, Checkbox } from '@ui/index'

/** Основная вкладка в анкете контрагента */
export const CardListenerTabPrimary = ({
    fieldsError, commpanyINNAuto, txtINN, txtKPP, isReadOnlyKPP, isAddressDisabled,
    txtCompanyPhone, txtCompanyEmail, txtCompanyName, txtCompanyNameShort,
    txtManagerPosition, txtActingOnBasis, txtLastName, txtFirstName, txtSecondName, txtInPersonWhom,
    txtAddress, txtRequisites, txtComment,
    setTxtSecondName, setTxtFirstName, setTxtLastName, setTxtManagerPosition,
    handleAutoINN, handleChangeINN, handleChangeKPP,
}: ICardCompanyTabPrimary) => {
    return <>
        <Flex gap="20px">
            <Flex gap="5px">
                <Divider prefix={<h4>Основная информация</h4>} />

                <Flex gap='15px'>
                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.inn ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">ИНН контрагента <p className='pulse'></p></Flex>
                            
                            <Input placeholder="ИНН контрагента" isReadOnly={commpanyINNAuto.value}
                                type={!commpanyINNAuto.value ? 'mask' : 'text'} mask='999999999999'
                                value={txtINN.value} onChange={(e) => handleChangeINN(e.target.value)}
                                suffix={
                                    <ToolTip title={commpanyINNAuto.value ? 'Ввести ИНН вручную' : 'Сгенерировать ИНН'} placement="left">
                                        <Checkbox right='2px' checked={commpanyINNAuto.value} onChange={(e) => handleAutoINN(e.target.checked)} />
                                    </ToolTip>
                                }
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.kpp ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">КПП контрагента {!isReadOnlyKPP.value && <p className='pulse'></p>}</Flex>
                            
                            <Input placeholder="КПП контрагента" mask='999999999' type='mask'
                                suffix={txtKPP.value && getInputButton('clear', txtKPP.reset)} isDisabled={isReadOnlyKPP.value}
                                value={txtKPP.value} onChange={(e) => handleChangeKPP(e.target.value)}
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.companyName ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" className="input_header">Телефон контрагента</Flex>

                            <Input placeholder="Телефон контрагента" {...txtCompanyPhone} 
                                suffix={txtCompanyPhone.value && getInputButton('clear', txtCompanyPhone.reset)}
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.companyNameShort ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" className="input_header">Email контрагента</Flex>
                            
                            <Input placeholder="Email контрагента" {...txtCompanyEmail}
                                suffix={txtCompanyEmail.value && getInputButton('clear', txtCompanyEmail.reset)} 
                            />
                        </Flex>

                    </Flex>

                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.companyName ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Полное наименование контрагента <p className='pulse'></p></Flex>

                            <Input placeholder="Полное наименование контрагента" {...txtCompanyName} 
                                suffix={txtCompanyName.value && getInputButton('clear', txtCompanyName.reset)}
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.companyNameShort ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Краткое наименование контрагента <p className='pulse'></p></Flex>
                            
                            <Input placeholder="Краткое наименование контрагента" {...txtCompanyNameShort}
                                suffix={txtCompanyNameShort.value && getInputButton('clear', txtCompanyNameShort.reset)} 
                            />
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>

            <Flex gap="5px">
                <Divider prefix={<h4>Руководитель</h4>} />

                <Flex gap='15px'>
                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.managerPosition ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Должность руководителя {(isReadOnlyKPP.value && !commpanyINNAuto.value) ? '' : <p className='pulse'></p>}</Flex>
                            
                            <Input placeholder="Должность руководителя"
                                value={txtManagerPosition}
                                onChange={(e) => setTxtManagerPosition(e.target.value)}
                                isDisabled={(isReadOnlyKPP.value && !commpanyINNAuto.value) ? true : false}
                                suffix={txtManagerPosition && getInputButton('clear', () => setTxtManagerPosition(''))}
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.actingOnBasis ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Действующего на основании {(isReadOnlyKPP.value && !commpanyINNAuto.value) ? '' : <p className='pulse'></p>}</Flex>
                            
                            <Input placeholder="Действующего на основании" {...txtActingOnBasis}
                                isDisabled={(isReadOnlyKPP.value && !commpanyINNAuto.value) ? true : false}
                                suffix={txtActingOnBasis.value && getInputButton('clear', txtActingOnBasis.reset)}
                            />
                        </Flex>
                    </Flex>

                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.lastName ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Фамилия руководителя <p className='pulse'></p></Flex>
                            
                            <Input placeholder="Фамилия руководителя"
                                value={txtLastName}
                                onChange={(e) => setTxtLastName(e.target.value)}
                                suffix={txtLastName && getInputButton('clear', () => setTxtLastName(''))}
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.firstName ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Имя руководителя <p className='pulse'></p></Flex>
                            
                            <Input placeholder="Имя руководителя"
                                value={txtFirstName}
                                onChange={(e) => setTxtFirstName(e.target.value)}
                                suffix={txtFirstName && getInputButton('clear', () => setTxtFirstName(''))} 
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px'>
                            <Flex flexDirection="row" alignItems='center' className="input_header">Отчество руководителя</Flex>
                            
                            <Input placeholder="Отчество руководителя"
                                value={txtSecondName}
                                onChange={(e) => setTxtSecondName(e.target.value)}
                                suffix={txtSecondName && getInputButton('clear', () => setTxtSecondName(''))} 
                            />
                        </Flex>
                    </Flex>

                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.inPersonWhom ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">В лице кого <p className='pulse'></p></Flex>
                            
                            <Input placeholder="Должность + Ф.И.О. руководителя" {...txtInPersonWhom}
                                suffix={txtInPersonWhom.value && getInputButton('clear', txtInPersonWhom.reset)} 
                            />
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>

            <Flex gap="5px">
                <Divider prefix={<h4>Прочее</h4>} />

                <Flex gap='15px'>
                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.address ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Юридический адрес <p className='pulse'></p></Flex>
                            
                            <AddressInput label="Юридический адрес" value={txtAddress.value} onChange={txtAddress.setValue}
                                loadSuggestions={getCompanyAddressSuggestions} isDisabled={isAddressDisabled}
                            />
                        </Flex>
                    </Flex>

                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.requisites ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Платёжные реквизиты <p className='pulse'></p></Flex>

                            <Textarea placeholder="Платёжные реквизиты" rows={6} 
                                value={txtRequisites.value} onChange={(e) => txtRequisites.setValue(e.target.value)}
                            />
                        </Flex>
                    </Flex>

                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px'>
                            <Flex flexDirection="row" className="input_header">Комментарий</Flex>

                            <Textarea placeholder="Комментарий" rows={5} 
                                value={txtComment.value} onChange={(e) => txtComment.setValue(e.target.value)}
                            />
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
    </>
}